module.exports = __webpack_public_path__ + "img/person.e5489d2d.svg";